// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7527) return "static/chunks/7527-15c715f1ba3fdba3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "e6b9a8b8752ff7a6" + ".js";
};